import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Cookie from "js-cookie";
const userToken = Cookie.get("token");
const baseUrl = process.env.VUE_APP_BASE_API_URL;
Vue.use(VueAxios, axios);

Vue.use(axios);

const getSaltoAkhir = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/saving/savings", {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESSALDOAKHIRSIM", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getMutasiRekening = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/saving/account-mutations", {
        params: {
          // noa: state.noa,
          saving_type: state.detailSimpanan[0].type,
          account_number: state.detailSimpanan[0].number
          // sertificate_number:
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESMUTATIONSIM", res);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
export default {
  getSaltoAkhir,
  getMutasiRekening
};
